import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { GridMainContainer, sxStyle } from '../styles';

const LoadingView = ({ searchType }) => (
  <GridMainContainer searchType={searchType} container justifyContent="center">
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{
        width: { xs: '100%', sm: '60%' },
        maxWidth: '800px',
        my: { xs: 2, sm: 4 },
      }}
    >
      <Grid item sx={sxStyle.gridPadding}>
        <CircularProgress color="primary" size={60} />
      </Grid>
    </Grid>
  </GridMainContainer>
);

export default LoadingView;
